import React, { useEffect } from 'react';

import { colors, layout } from 'Constants';

// State
import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';

import { Container, Header, Anchor } from 'Components/core';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';
import PaddedContainer from 'Components/core/PaddedContainer';

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_BD);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        let resources = state.benefitDetails?.resource;

        return (
          <Container
          
            column
            maxWidth
            style={{ margin: 'auto',  }}
          >
            <HeaderV2 title={'Additional Benefit Information and Resources'}></HeaderV2>
            <PaddedContainer seperation={20} style={{ paddingTop: 20 }} column>
              {resources.map(material => (
                <Container seperation="20px" style={{ color: colors.accent,marginBottom:15 }}>
                  <FontAwesomeIcon icon={faFile} />
                  <Anchor
                    code={CODES.BD_MAT_LINK}
                    to={material.url}
                    style={{ alignSelf: 'flex-start' }}
                  >
                    {material.label}
                  </Anchor>
                </Container>
              ))}
            </PaddedContainer>
          </Container>
        );
      }}
    </Subscribe>
  );
};
